// extracted by mini-css-extract-plugin
export default {"refresh":"styles_refresh__2RaV7","container":"styles_container__WpuDy","message":"styles_message__qZMpr"};